export const Subtract = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 16H24" stroke="currentColor" stroke-width="2"/>
</svg>`;
